
import { TimeRange, HistoricalStat, Customer } from './types';
import { groupCustomersByPlan, isPendingUser } from './customerUtils';
import { toZonedTime } from 'date-fns-tz';

/**
 * Generates historical subscription data for the given time range
 */
export const generateHistoricalData = (range: TimeRange, customerData: Customer[]): HistoricalStat[] => {
  if (!customerData || customerData.length === 0) {
    return [];
  }
  
  // Use New Zealand timezone for date calculations
  const today = toZonedTime(new Date(), 'Pacific/Auckland');
  let days: number;
  
  switch (range) {
    case '1d':
      days = 1;
      break;
    case '7d':
      days = 7;
      break;
    case '30d':
      days = 30;
      break;
    case '90d':
      days = 90;
      break;
    case 'all':
    default:
      days = 180; // Use 6 months for "all time" or adjust as needed
      break;
  }
  
  // Sort customers by creation date
  const sortedCustomers = [...customerData].sort((a, b) => 
    new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
  
  const historicalData: HistoricalStat[] = [];
  
  // Generate data points for each day
  for (let i = days; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD format
    
    // Get customer counts grouped by plan
    const counts = groupCustomersByPlan(sortedCustomers, date);
    
    console.log(`Historical data for ${dateStr}: pending=${counts.pending}, monthly=${counts.monthly}, annual=${counts.annual}, lifetime=${counts.lifetime}, canceled=${counts.canceled}`);
    
    const dataPoint: HistoricalStat = {
      date: dateStr,
      pending: counts.pending,
      monthly: counts.monthly,
      annual: counts.annual,
      lifetime: counts.lifetime,
      canceled: counts.canceled,
      total: counts.total
    };
    
    historicalData.push(dataPoint);
  }
  
  return historicalData;
};
